/* Alix Avien TR — mobil ürün sayfası geliştirmeleri.
   kur_cro.py ekliyor; tema tarafından üretilmedi.

   1) Başlık + Okendo puanı GALERİNİN ÜSTÜNE taşınır — akış içinde,
      normal blok olarak. Önce görselin ÜZERİNE mutlak konumlu bindirme
      denendi: hem görselin içine giriyordu hem de galeri açılışta 0
      yükseklikte olduğu için hiç kurulamıyordu. Akışta taşımak ikisini
      de çözüyor ve galeriye hiç bağımlı değil.
   2) Ton segmentleri renk ailesine göre (Nude, Pembe, Kırmızı, Bordo,
      Mor, Kahve) — swatch'ların gerçek rengi HSL'e çevrilip gruplanıyor,
      elle etiketleme yok.
   3) Yapışkan çubukta ton göstergesi (renk çipi + tam ad).
      Alttan açılan çekmece KALDIRILDI. */
(function () {
  var MOBIL = window.matchMedia('(max-width: 767px)');

  function gorunur(list, minYuk) {
    var enIyi = null, enYuk = minYuk || 100;
    for (var i = 0; i < list.length; i++) {
      var h = list[i].getBoundingClientRect().height;
      if (h > enYuk) { enYuk = h; enIyi = list[i]; }
    }
    return enIyi;
  }
  function anaBilgi() {
    var c = document.querySelectorAll('.product-info');
    for (var i = 0; i < c.length; i++) {
      if (c[i].querySelector('.color-watches') && c[i].getBoundingClientRect().height > 100) return c[i];
    }
    return gorunur(c, 100);
  }
  /* Yükseklik koşulu OLMADAN: başlık taşıması sayfa yerleşmeden
     yapılmalı, yoksa başlık önce görselin ALTINDA görünüp sonra yukarı
     zıplıyor (kullanıcı bunu "yine altta" olarak gördü). Ölçüt olarak
     quick-view kopyasını elemek için `.splide-image` kardeşi aranıyor. */
  function anaBilgiHizli() {
    var c = document.querySelectorAll('.product-info');
    for (var i = 0; i < c.length; i++) {
      var b = c[i].closest('[id^="shopify-section"]');
      if (b && b.id.indexOf('quick-view') === -1 && c[i].querySelector('.color-watches')) return c[i];
    }
    return anaBilgi();
  }
  function swatchlar() {
    var k = anaBilgi();
    if (!k) return [];
    return [].slice.call(k.querySelectorAll('.color-watches'))
      .filter(function (l) { var i = l.previousElementSibling; return i && i.classList.contains('input-radio'); });
  }
  function tonAdi(l) { var i = l.previousElementSibling; return (i && i.getAttribute('aria-label')) || ''; }
  function renkOku(el) {
    if (!el) return null;
    var kat = [getComputedStyle(el), getComputedStyle(el, '::before')];
    for (var i = 0; i < kat.length; i++) {
      var cs = kat[i];
      if (cs.backgroundImage && cs.backgroundImage !== 'none') return cs.backgroundImage;
      if (cs.backgroundColor && !/rgba\(0, 0, 0, 0\)|transparent/.test(cs.backgroundColor)) return cs.backgroundColor;
    }
    return null;
  }
  function rgbAl(el) {
    var kat = [getComputedStyle(el), getComputedStyle(el, '::before')];
    for (var i = 0; i < kat.length; i++) {
      var bc = kat[i].backgroundColor || '';
      if (bc.indexOf('rgba(0, 0, 0, 0)') !== -1) continue;
      var m = bc.match(/(\d+),\s*(\d+),\s*(\d+)/);
      if (m) return [+m[1], +m[2], +m[3]];
    }
    return null;
  }
  function hsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), d = mx - mn;
    var h = 0, l = (mx + mn) / 2, s = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1));
    if (d !== 0) {
      if (mx === r) h = 60 * (((g - b) / d) % 6);
      else if (mx === g) h = 60 * ((b - r) / d + 2);
      else h = 60 * ((r - g) / d + 4);
    }
    if (h < 0) h += 360;
    return { h: h, s: s, l: l };
  }
  /* Renk ailesi. Kozmetik tonlarının çoğu 340°-40° arasında yığıldığı
     için o aralık açıklık ve doygunlukla ayrıca bölünüyor; yoksa 24 ton
     tek kovaya düşerdi. */
  function aile(el) {
    var c = rgbAl(el);
    if (!c) return null;
    var x = hsl(c[0], c[1], c[2]);
    if (x.s < 0.16) return 'notr';
    if (x.h >= 260 && x.h < 310) return 'mor';
    if (x.h >= 310 && x.h < 345) return 'pembe';
    if (x.h >= 345 || x.h < 12) return x.l < 0.32 ? 'bordo' : (x.l > 0.62 ? 'pembe' : 'kirmizi');
    if (x.h >= 12 && x.h < 45) return x.l < 0.42 ? 'kahve' : 'nude';
    return 'diger';
  }
  var ETIKET = { nude: 'Nude', pembe: 'Pink', kirmizi: 'Red', bordo: 'Burgundy',
                 mor: 'Purple', kahve: 'Brown', notr: 'Neutral', diger: 'Other' };


  /* ---------- galeride varyant görsellerini filtrele ----------
     İstenen: galeride varyantların ana görselleri TOPLUCA görünmesin;
     yalnızca SEÇİLİ varyantın görseli + varyanta bağlı olmayan liste
     görselleri kalsın.

     Temanın kendi mekanizması (`data-media-option` + `media_active`)
     yalnızca tüm medyası varyanta bağlı ürünlerde kuruluyor; karışık
     medyalı ürünlerde hiç kurulmuyor (ölçüldü: dudak kaleminde 0
     gruplama elemanı, 38 slaytın 9'u varyant görseli olduğu halde).
     Bu yüzden filtre burada yapılıyor.

     Varyant görselleri, tema zaten sayfaya basıyor:
       <script type="application/json" data-option-value-id data-resource>
     içinde her seçenek değerinin varyant JSON'u var. Seçili olanı,
     işaretli radio'nun id'si ile `data-resource` eşleşmesinden buluyoruz. */
  function dosyaAdi(u) {
    if (!u) return null;
    return String(u).split('?')[0].split('/').pop();
  }
  /* pdp-v2: varyant filtresinden sonra (ya da ürün tek görselliyse) tek
     görsel kalıyorsa küçük görsel şeridi, noktalar ve oklar basılmıyor. */
  function tekMedya() {
    var bilgi = anaBilgi();
    var bolum = bilgi && bilgi.closest('[id^="shopify-section"]');
    if (!bolum) return;
    /* Fade galeride slaytlar hiç gizlenmiyor (galeriFiltrele), ama tema
       galeriyi yeniden kurarken slaytlar bir an display:none oluyor; o anda
       sayılırsa n=1 → şerit kapanıp açılıyor (CLS ~0.15, 22.10 ölçümü).
       Fade'de display'e bakma. */
    var g = bolum.querySelector('.splide.swiper-product');
    var fade = !!g && (g.classList.contains('splide--fade') || g.classList.contains('transition-fade'));
    var n = [].filter.call(bolum.querySelectorAll('.splide.swiper-product .splide__slide:not(.splide__slide--clone)'),
      function (el) { return !el.classList.contains('alix-medya-gizli') && (fade || getComputedStyle(el).display !== 'none'); }).length;
    /* n=0: galeri henüz çizilmemiş demek, "tek görsel" demek DEĞİL. Karar
       verme; sonraki çağrı (load / dene döngüsü) karar verir. Eskiden 0 da
       "tek" sayılıyor ve sınıf kalıcı kalıyordu → çok görselli üründe
       şerit, nokta ve oklar gizleniyordu (parite raporu, 02.10). */
    if (!n) return;
    bolum.classList.toggle('alix-tek-medya', n === 1);
    /* Sunucu tahmini (data-alix-tek) JS sayımından farklıysa JS'inki geçerli. */
    [].forEach.call(bolum.querySelectorAll('[data-alix-tek]'), function (el) { el.setAttribute('data-alix-tek', n === 1 ? '1' : '0'); });
  }
  function galeriFiltrele() {
    var bilgi = anaBilgi();
    if (!bilgi) return;
    var bolum = bilgi.closest('[id^="shopify-section"]');
    if (!bolum) return;

    var veri = bilgi.querySelectorAll('script[type="application/json"][data-option-value-id]');
    if (!veri.length) return;

    var varyantGorselleri = {}, secili = null;
    var isaretli = bilgi.querySelector('.input-radio:checked');
    var isaretliId = isaretli && isaretli.id;

    for (var i = 0; i < veri.length; i++) {
      var v;
      try { v = JSON.parse(veri[i].textContent); } catch (e) { continue; }
      var src = v && v.featured_image && v.featured_image.src;
      var ad = dosyaAdi(src);
      if (!ad) continue;
      varyantGorselleri[ad] = true;
      if (isaretliId && veri[i].getAttribute('data-resource') === isaretliId) secili = ad;
    }
    if (!Object.keys(varyantGorselleri).length) return;

    function uygula(kok, secici) {
      [].forEach.call(kok.querySelectorAll(secici), function (el) {
        var img = el.matches('img') ? el : el.querySelector('img');
        var ad = dosyaAdi(img && (img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src')));
        if (!ad) return;
        // Varyant görseli VE seçili olan değilse gizle. Liste görselleri
        // (varyant listesinde olmayanlar) hiç dokunulmadan kalır.
        var gizle = !!varyantGorselleri[ad] && ad !== secili;
        el.classList.toggle('alix-medya-gizli', gizle);
      });
    }
    /* Fade modunda (Splide "type":"fade") slaytlar üst üste duruyor ve
       her slayt kendi sırası kadar transform ile geri çekiliyor. Bir
       slayta display:none verilince sonraki slaytlar akışta bir slayt
       sola kayıyor, transform ise eski sıraya göre kalıyor → aktif slayt
       görünür alanın DIŞINA düşüyor (ölçüm, fixing spray 390: aktif slayt
       x=-226, görsel boş). Bu yüzden fade'de slayt gizlenmiyor; yalnız
       küçük resimler gizleniyor ve seçili varyantın görseline gidiliyor.
       Kaydırmalı (loop/slide) galeride eski davranış sürüyor. */
    var galeri = bolum.querySelector('.splide.swiper-product');
    var fade = !!galeri && (galeri.classList.contains('splide--fade') || galeri.classList.contains('transition-fade'));
    if (fade) {
      [].forEach.call(galeri.querySelectorAll('.splide__slide.alix-medya-gizli'), function (el) {
        el.classList.remove('alix-medya-gizli');
      });
      var sp = galeri.splide;
      if (secili && sp && typeof sp.go === 'function') {
        var slaytlar = [].slice.call(galeri.querySelectorAll('.splide__slide:not(.splide__slide--clone)'));
        for (var j = 0; j < slaytlar.length; j++) {
          var im = slaytlar[j].querySelector('img');
          if (dosyaAdi(im && (im.currentSrc || im.getAttribute('src') || im.getAttribute('data-src'))) === secili) {
            if (sp.index !== j) sp.go(j);
            break;
          }
        }
      }
    } else {
      uygula(bolum, '.splide.swiper-product .splide__slide');
    }
    uygula(bolum, '[id^="x-product-thumbnail"] .x-thumbnail');
    tekMedya();
  }


  /* ---------- yan rayda 6 görsel + "+N" ----------
     Ray uzun ürünlerde ekranı boydan boya kaplıyordu. İlk 6 küçük görsel
     gösterilip kalanı "+N" rozetinde toplanıyor; rozete dokununca hepsi
     açılıyor. Sayım GÖRÜNÜR görseller üzerinden yapılıyor: varyant
     filtresi gizlenenleri hesaba katmamalı. */
  var RAY_LIMIT = 6;
  var SEGMENT_LIMIT = 5;   // Satin Touch 5 segment istiyor
  function rayKisalt() {
    var bilgi = anaBilgi();
    if (!bilgi) return;
    var bolum = bilgi.closest('[id^="shopify-section"]');
    var ray = bolum && bolum.querySelector('[id^="x-product-thumbnail"]');
    if (!ray) return;
    if (ray.dataset.alixAcik === '1') return;   // kullanıcı hepsini açtıysa karışma

    var eski = ray.querySelector('.alix-ray-fazlasi');
    if (eski) eski.remove();

    /* Yalnızca KENDİ varyant filtremize bakılıyor. Önce temanın
       data-media-option/media_active sınıfları da hesaba katılıyordu; ama
       tema filtresi bazı yüklemelerde hiç uygulanmıyor ve o zaman sayım
       şişiyordu (ölçüm: 6 yerine 13 küçük görsel gösterildi, rozet "+2"
       çıktı). Kendi filtremiz her yüklemede aynı sonucu veriyor. */
    var hepsi = [].slice.call(ray.querySelectorAll('.x-thumbnail'));
    var gorunur = hepsi.filter(function (t) { return !t.classList.contains('alix-medya-gizli'); });
    hepsi.forEach(function (t) { t.classList.remove('alix-ray-fazla'); });

    if (gorunur.length <= RAY_LIMIT) return;

    var kalan = gorunur.length - RAY_LIMIT;
    gorunur.slice(RAY_LIMIT).forEach(function (t) { t.classList.add('alix-ray-fazla'); });

    /* Rozet AYRI bir kutu değil, 6. küçük görselin ÜZERİNDE katman —
       kullanıcının verdiği referans böyle ("3+"). */
    var son = gorunur[RAY_LIMIT - 1];
    if (!son) return;
    son.classList.add('alix-ray-son');
    var rozet = document.createElement('button');
    rozet.type = 'button';
    rozet.className = 'alix-ray-fazlasi';
    rozet.textContent = kalan + '+';
    rozet.setAttribute('aria-label', 'Show ' + kalan + ' more images');
    rozet.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      ray.dataset.alixAcik = '1';
      [].forEach.call(ray.querySelectorAll('.alix-ray-fazla'), function (t) {
        t.classList.remove('alix-ray-fazla');
      });
      son.classList.remove('alix-ray-son');
      rozet.remove();
    });
    if (getComputedStyle(son).position === 'static') son.style.position = 'relative';
    son.appendChild(rozet);
  }

  /* Okendo kompakt modda yalnızca yıldızları basıyor; puan değeri ve
     yorum sayısı erişilebilirlik metninde duruyor ama görünmüyor.
     Oradan okuyup görünür hale getiriyoruz. HER GENİŞLİKTE çalışır —
     masaüstünde de renk seçeneklerinin üzerinde görünmesi istendi. */
  function puanMetniEkle(puan, hedef) {
    if (!puan || puan.dataset.alixPuanMetni === '1') return;
    var ham = (puan.textContent || '').replace(/\s+/g, ' ');
    var pv = ham.match(/([\d]+[.,][\d]+|[\d]+)/);
    var yc = ham.match(/(\d+)\s*(?:Yorum|reviews?)/i);
    if (!pv && !yc) return;
    var et = document.createElement('span');
    et.className = 'alix-puan-metin';
    var parca = [];
    if (pv) parca.push(pv[1].replace(',', '.'));
    if (yc) parca.push(yc[1] + (yc[1] === '1' ? ' review' : ' reviews'));
    et.textContent = parca.join(' · ');
    puan.dataset.alixPuanMetni = '1';
    if (hedef) { hedef.appendChild(et); }
    else if (puan.parentElement) {
      puan.classList.add('alix-puan-yildiz');
      puan.parentElement.insertBefore(et, puan.nextSibling);
    }
  }

  /* ---------- 1) başlık + puan galerinin ÜSTÜNE (akışta) ---------- */
  function ustuneTasi() {
    /* Kutu product-template.liquid'deki erken betikle sayfa ayrıştırılırken
       kuruluyor (CLS). Burada yalnız Okendo puan metni ve kopya başlık tamamlanır. */
    /* Kutunun yeri sunucuda boş olarak ayrılıyor ([data-alix-yer]); dolu
       sayılması için içinde taşınmış öğe olmalı. */
    var dolu = document.querySelector('.alix-ust-bilgi .alix-tasindi');
    var hazir = dolu && dolu.closest('.alix-ust-bilgi');
    if (hazir) {
      var hp = hazir.querySelector('.okendo-star-rating');
      if (hp) puanMetniEkle(hp, hp.parentElement);
      kopyaBasligiGizle(anaBilgiHizli());
      return;
    }
    var bilgi = anaBilgi();
    if (!bilgi) return;
    /* Sayfada gizli bir quick-view kopyası da var: aynı sınıfı taşıyor
       ama genişliği ve yüksekliği 0. Düz querySelector onu yakalıyordu
       ve blok görünmez bir yere taşınıyordu. Bu yüzden ana bilgi
       bloğuyla AYNI section içinde ve genişliği > 0 olan aranıyor. */
    var bolum = bilgi.closest('[id^="shopify-section"], section') || document;
    var adaylar = bolum.querySelectorAll('.product-media-container');
    var medya = null;
    for (var i = 0; i < adaylar.length; i++) {
      if (adaylar[i].getBoundingClientRect().width > 0) { medya = adaylar[i]; break; }
    }
    if (!medya || !medya.parentElement) return;

    var baslik = bilgi.querySelector('.mb-3.w-full.overflow-hidden');
    var puan = bilgi.querySelector('.okendo-star-rating, .alix-puan');
    var yer = bolum.querySelector('.alix-ust-bilgi[data-alix-yer]');
    if (!baslik && !puan) { if (yer) yer.parentNode.removeChild(yer); return; }

    var kutu = yer || document.createElement('div');
    kutu.className = 'alix-ust-bilgi';
    if (baslik) { baslik.classList.add('alix-tasindi'); kutu.appendChild(baslik); }
    if (puan) {
      puan.classList.add('alix-tasindi');
      var sarma = document.createElement('div');
      sarma.className = 'alix-puan-satiri';
      sarma.appendChild(puan);
      puanMetniEkle(puan, sarma);
      kutu.appendChild(sarma);
    }
    if (!yer) medya.parentElement.insertBefore(kutu, medya);
    kopyaBasligiGizle(bilgi);
  }

  /* `product_name` bloğu masaüstünde başlık göstersin diye açıldı; ama
     mobilde başlığı zaten galerinin üstüne taşıyoruz, o yüzden akışta
     kalan ikinci başlık gizleniyor (ölçüm: y=147 taşınan, y=828 kopya). */
  function kopyaBasligiGizle(bilgi) {
    if (!MOBIL.matches || !bilgi) return;
    [].forEach.call(bilgi.querySelectorAll('.product-title'), function (t) {
      if (t.closest('.alix-ust-bilgi')) return;
      var kutu = t.closest('.mb-3') || t;
      kutu.classList.add('alix-kopya-gizli');
    });
  }

  /* ---------- 2) renk ailesi segmentleri ---------- */
  /* Ürüne özel segment tanımı (alix.ton_segment metafield'ı). Varsa
     isimler oradan gelir — "Karamel & Kum", "Yakut & Kadife" gibi
     pazarlama isimleri. Yoksa aşağıdaki renk analizine düşülür. */
  function segmentTanimi() {
    var s = document.getElementById('alix-ton-segment');
    if (!s) return null;
    try {
      var d = JSON.parse(s.textContent);
      return (d && d.segmentler && d.segmentler.length) ? d.segmentler : null;
    } catch (e) { return null; }
  }

  /* Filtre yalnız KAPSAYICININ içindeki dairelere uygulanıyor; ürünün
     ikinci renk seçeneği (ör. kılıf rengi) ayrı bir fieldset'te ve
     segmentlerden etkilenmemeli. */
  function alixSegmentKapsam(kapsayici) {
    return [].slice.call(kapsayici.querySelectorAll('.color-watches'))
      .filter(function (l) {
        var i = l.previousElementSibling;
        return i && i.classList.contains('input-radio');
      });
  }

  /* Kullanıcının seçtiği segment. Tema her ton seçiminde seçiciyi baştan
     çiziyor (variant-select.js `_updateOptionValues`: element.innerHTML =
     …) ve çubuk DOM'dan düşüyor; yeniden kurulurken filtre buradan geri
     yüklenir, "All"a dönmez. */
  var seciliFiltre = 'hepsi';

  function filtreUygula(bar, kapsayici, f, anahtarAl) {
    [].forEach.call(bar.children, function (x) {
      var sec = x.dataset.alixFiltre === f;
      x.classList.toggle('secili', sec);
      x.setAttribute('aria-selected', sec ? 'true' : 'false');
    });
    alixSegmentKapsam(kapsayici).forEach(function (l) {
      l.classList.toggle('alix-gizli', f !== 'hepsi' && anahtarAl(l) !== f);
    });
  }

  function segmentleriBas(kapsayici, girdiler, anahtarAl) {
    var bar = document.createElement('div');
    bar.className = 'alix-segment';
    bar.setAttribute('role', 'tablist');
    girdiler.forEach(function (s, idx) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'alix-segment-dugme' + (idx === 0 ? ' secili' : '');
      b.dataset.alixFiltre = s[0];
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');
      b.innerHTML = '<span class="alix-segment-ad"></span> <span class="alix-segment-say">' + s[2] + '</span>';
      b.querySelector('.alix-segment-ad').textContent = s[1];
      if (s[3]) b.style.setProperty('--alix-seg-renk', s[3]);
      bar.appendChild(b);
    });
    bar.addEventListener('click', function (e) {
      var d = e.target.closest('.alix-segment-dugme');
      if (!d) return;
      seciliFiltre = d.dataset.alixFiltre;
      filtreUygula(bar, kapsayici, seciliFiltre, anahtarAl);
    });
    kapsayici.insertBefore(bar, kapsayici.firstChild);
    /* Yeniden kurulumda önceki seçim geri yüklenir; o segment artık yoksa
       (ton listesi değiştiyse) "All"a düşülür. */
    var varMi = girdiler.some(function (s) { return s[0] === seciliFiltre; });
    if (!varMi) seciliFiltre = 'hepsi';
    if (seciliFiltre !== 'hepsi') filtreUygula(bar, kapsayici, seciliFiltre, anahtarAl);
  }

  /* Tema seçiciyi yeniden çizdiğinde çubuğu geri kur. Gözlemci
     `.product-info` kökünde (o düğüm yeniden çizimde yerinde kalıyor,
     ölçüldü). Çubuk varken hiçbir şey yapılmaz → kendi eklememiz yeni bir
     kurulum tetiklemez, çift çubuk ve döngü oluşmaz. Geri çağrı boyamadan
     önce (mikro görev) çalıştığı için çubuk göz kırpmaz. */
  var segmentGozcu = null;
  function segmentGozle(kok) {
    if (segmentGozcu || !kok || !window.MutationObserver) return;
    segmentGozcu = new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        if (!ms[i].addedNodes.length) continue;
        if (!document.querySelector('.alix-segment')) segmentler();
        return;
      }
    });
    segmentGozcu.observe(kok, { childList: true, subtree: true });
  }

  function segmentler() {
    var tumu = swatchlar();
    /* Eşik (Samet 30.09): segment TANIMI olan üründe 4 ton yeter; tanımsız üründe renk
       analizi yedeği yalnız 8+ tonda çalışır (küçük ürünlerde tahmini gruplama yok). */
    var ESIK = segmentTanimi() ? 4 : 8;
    if (tumu.length < ESIK || document.querySelector('.alix-segment')) return;

    /* En çok dairesi olan seçenek segmentlenir. Ürünün ikinci renk
       seçeneği (set sayfasında "Kılıf Rengi") kapsam dışında kalır. */
    var kapsayici = null, enCok = 0;
    tumu.forEach(function (l) {
      var f = l.closest('fieldset, .x-variant-picker');
      if (!f) return;
      var n = alixSegmentKapsam(f).length;
      if (n > enCok) { enCok = n; kapsayici = f; }
    });
    if (!kapsayici) return;
    var sw = alixSegmentKapsam(kapsayici);
    if (sw.length < ESIK) return;

    var tanim = segmentTanimi();
    if (tanim) {
      var esle = {};
      tanim.forEach(function (g, i) {
        (g.tonlar || []).forEach(function (t) { esle[String(t).trim()] = 'g' + i; });
      });
      var say = {}, etiketli = 0;
      sw.forEach(function (l) {
        var k = esle[tonAdi(l).trim()];
        if (!k) return;
        l.dataset.alixAile = k;
        say[k] = (say[k] || 0) + 1;
        etiketli++;
      });
      /* Tanım eşleşmiyorsa (ton adı değişmiş olabilir) renk analizine düş. */
      if (etiketli >= sw.length * 0.8) {
        var girdiler = [['hepsi', 'All', sw.length, null]];
        tanim.slice(0, SEGMENT_LIMIT).forEach(function (g, i) {
          if (say['g' + i]) girdiler.push(['g' + i, g.ad, say['g' + i], g.renk]);
        });
        if (girdiler.length >= 3) {
          segmentleriBas(kapsayici, girdiler, function (l) { return l.dataset.alixAile; });
          return;
        }
      }
      sw.forEach(function (l) { delete l.dataset.alixAile; });
    }
    if (sw.length < 8) return;  // renk analizi yedeği yalnız 8+ tonda

    var say = {}, etiketli = 0;
    sw.forEach(function (l) {
      var a = aile(l);
      if (!a) return;
      l.dataset.alixAile = a;
      say[a] = (say[a] || 0) + 1;
      etiketli++;
    });
    if (etiketli < sw.length * 0.6) return;

    // En az 2 üyesi olan aileler, çoktan aza; en fazla 4 sekme.
    var aileler = Object.keys(say).filter(function (k) { return say[k] >= 2; })
      .sort(function (a, b) { return say[b] - say[a]; }).slice(0, SEGMENT_LIMIT);
    if (aileler.length < 2) return;

    segmentleriBas(kapsayici,
      [['hepsi', 'All', sw.length, null]].concat(aileler.map(function (k) {
        return [k, ETIKET[k] || k, say[k], null];
      })),
      function (l) { return l.dataset.alixAile; });
  }

  /* ---------- 3) yapışkan çubuktaki gösterge ---------- */
  function gostergeKur() {
    var kutu = document.querySelector('.alix-sticky-ton');
    if (!kutu || kutu.dataset.alixHazir) return;
    kutu.dataset.alixHazir = '1';
    var adEl = kutu.querySelector('.alix-sticky-ton-ad');
    var cipEl = kutu.querySelector('.alix-sticky-ton-cip');

    function guncelle() {
      var k = anaBilgi();
      var secim = k && k.querySelector('.input-radio:checked');
      if (secim && adEl) adEl.textContent = secim.getAttribute('aria-label') || adEl.textContent;
      var l = secim && secim.nextElementSibling;
      var boya = l && renkOku(l);
      if (cipEl && boya) { cipEl.style.background = boya; cipEl.style.backgroundSize = 'cover'; }
    }
    var kok = anaBilgi() || document.body;
    new MutationObserver(guncelle).observe(kok, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['checked', 'class']
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.product-info .color-watches')) {
        setTimeout(guncelle, 80); setTimeout(guncelle, 700);
        setTimeout(function(){ galeriFiltrele(); rayKisalt(); }, 120);
        setTimeout(function(){ galeriFiltrele(); rayKisalt(); }, 900);
      }
    }, true);
    guncelle();
  }

  /* Galeri ile fiyat arasında 32px saf boşluk vardı: ürün şablonunda
     İKİ adet boş `custom-html` bloğu duruyor, yükseklikleri 0 ama her
     birinin margin-bottom'ı 16px. CSS ile "yüksekliği 0 olanı" seçmek
     mümkün değil, o yüzden ölçüp burada sıfırlanıyor. */
  function bosBloklariKis() {
    var k = anaBilgi();
    if (!k) return;
    [].forEach.call(k.querySelectorAll('.custom-html'), function (e) {
      if (e.offsetHeight === 0 && !e.dataset.alixKisildi) {
        e.dataset.alixKisildi = '1';
        e.style.marginBottom = '0';
        e.style.marginTop = '0';
      }
    });
  }

  /* GALERİ KİLİTLENMESİ.
     media-gallery.liquid:306 galeriyi `x-intersect.once` ile mount
     ediyor: `$store.xSplide.load($el, {...})`. Ama element mount
     edilmeden önce 0 yükseklikte; IntersectionObserver 0 alanlı bir
     elementi güvenilir biçimde "görünür" saymıyor, dolayısıyla load
     hiç çağrılmıyor ve element 0 yükseklikte kalıyor — kilitlenme.
     Ölçüldü: 12sn beklendi, `is-initialized` yok, 24 slayt var,
     aktif slayt 0. Kullanıcı kaydırınca observer yeniden değerlendirip
     galeriyi açıyor; bu yüzden ürün sayfası boş görsel alanıyla
     açılıp ancak kaydırınca doluyor.

     DENENEN VE İŞE YARAMAYAN İKİ ÇÖZÜM:
       1) theme.js'te `alpine:init` kayıtlarını rAF'tan çıkarıp senkrona
          almak (9 kayıt) — galeri yine açılmadı, geri alındı.
       2) Mount olmadıysa 1px kaydırıp geri almak (observer'ı yeniden
          tetiklemek için) — yine açılmadı, kaldırıldı.

     NOT: Galeri bazı yüklemelerde sorunsuz açılıyor (ekran
     görüntüleriyle görüldü). Bu davranışın gerçek cihazlarda mı yoksa
     yalnızca otomasyon ortamında mı olduğu DOĞRULANMADI. */

  function kur() {
    var k = anaBilgi();
    if (!k) return;
    bosBloklariKis();
    segmentler();
    segmentGozle(k);
    tekMedya();
    /* Masaüstünde blok taşınmıyor (yerleşim korunuyor) ama puan metni
       orada da isteniyor: yıldızların yanına ekleniyor. */
    if (!MOBIL.matches) {
      puanMetniEkle(k.querySelector('.okendo-star-rating, .alix-puan'), null);
      return;
    }
    ustuneTasi();
    gostergeKur();
    galeriFiltrele();
    tekMedya();
    rayKisalt();
  }

  window.addEventListener('load', function () { tekMedya(); setTimeout(tekMedya, 1500); });

  var deneme = 0;
  function dene() {
    kur();
    var ray = document.querySelector('[id^="x-product-thumbnail"] .x-thumbnail');
    var eksik = !document.querySelector('.alix-segment') ||
                (MOBIL.matches && !document.querySelector('.alix-ust-bilgi .alix-tasindi')) ||
                (MOBIL.matches && ray && !document.querySelector('.alix-ray-fazlasi')
                 && !document.querySelector('[id^="x-product-thumbnail"][data-alix-acik]'));
    if (eksik && ++deneme < 40) setTimeout(dene, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', dene);
  else dene();
})();
